import React, {
	useEffect
}from "react"
import {
	Modal
}from "antd"
import i18n from "./localization"
import RegisterAdmin from "../../RegisterByAdmin/index"
import {
	useSelector
}from "react-redux"
import {
	Scrollbars
}from "react-custom-scrollbars"
import "../style.css"

const ReOrgCreateUpdateForm = (props) => {
	const isRu = useSelector(state => state.globalReducer.isRu)
	const { visible, setVisible, reOrg, setReOrg } = props
	const { registerByAdminSuccess } = useSelector((state) => state.userReducer)

	function handleCancel(){
		setVisible(false)
		setReOrg(null)
	}

	useEffect(() => {
		if (registerByAdminSuccess)
			handleCancel()
	}, [registerByAdminSuccess])

	return (
		<Modal
			footer={ null }
			title={ i18n.headerRegister[isRu] }
			visible={ visible }
			width={ 1000 }
			onCancel={ handleCancel }
		>
			<Scrollbars
				autoHeight
				autoHide
				autoHeightMax={ 700 }
			>
				<RegisterAdmin reOrg={ reOrg } isRegByAdminPage={false} />
			</Scrollbars>
		</Modal>
	)
}
export default ReOrgCreateUpdateForm
